// FontAwesome SVG Icon Configuration
// This file registers only the icons we actually use (tree-shaking)

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// Import only the icons you actually use
// Organized by category for easy maintenance
import {
  // Text Formatting
  faBold,
  faItalic,
  faUnderline,
  faSmile,
  // Navigation & UI
  faBars,
  faChartPie,
  faMobileAlt,
  faUserCircle,
  faTimes,
  faChevronDown,
  faChevronUp,
  faChevronLeft,
  faChevronRight,
  faEllipsisV,
  faEllipsisH,
  faArrowLeft,
  faCaretDown,
  faCaretUp,
  
  // User & Account
  faUser,
  faUsers,
  faCog,
  faSignOutAlt,
  faKey,
  faCrown,
  faReceipt,
  faLock,
  faShieldAlt,
  faIdCard,
  
  // Actions
  faPlus,
  faEdit,
  faTrash,
  faSave,
  faCheck,
  faCopy,
  faDownload,
  faUpload,
  faRefresh,
  faSyncAlt,
  faPowerOff,
  faRedo,
  faUndo,
  faMagic,
  faWandMagicSparkles,
  
  // Visibility
  faEye,
  faEyeSlash,
  
  // Search & Filter
  faSearch,
  faFilter,
  faSort,
  faSortUp,
  faSortDown,
  
  // Date & Time
  faCalendar,
  faClock,
  faCalendarTimes,
  faInfinity,
  
  // Communication
  faEnvelope,
  faPhone,
  faBell,
  
  // Content
  faFileAlt,
  faFileCsv,
  faImage,
  faLink,
  faFolder,
  faFolderOpen,
  faFile,
  faDatabase,
  faInbox,
  faPlusCircle,
  faFileContract,
  
  // Status & Indicators
  faSpinner,
  faCircleNotch,
  faExclamationTriangle,
  faExclamationCircle,
  faInfoCircle,
  faCheckCircle,
  faTimesCircle,
  faQuestionCircle,
  
  // Business & Apps
  faHome,
  faChartBar,
  faChartLine,
  faGamepad,
  faTicketAlt,
  faGlobe,
  faCreditCard,
  faStore,
  faBullhorn,
  faBroadcastTower,
  faLayerGroup,
  faRocket,
  
  // Media Controls
  faPlay,
  faPause,
  faStop,
  
  // Social & Sharing
  faHeart,
  faStar,
  
  // Settings & Tools
  faCogs,
  faPalette,
  
  // Lists & Organization
  faList,
  faListAlt,
  faThLarge,
  
  // Other common icons
  faTrophy,
  faAward,
  faGift,
  faMapMarkerAlt,
  faBuilding,
  faArchive,
  faSortAmountDownAlt,
  faSortAmountUp,
  faArrowTrendUp,
  faArrowTrendDown,
  faArrowRight,
  faListOl,
  faListUl,
  // Game-specific icons
  faHammer,
  faSnowflake,
  faPaperPlane,
  faFrown,
  faCircle,
  faDesktop,
} from '@fortawesome/free-solid-svg-icons'

// Import brand icons
import {
  faGoogle,
  faApple,
  faMicrosoft,
} from '@fortawesome/free-brands-svg-icons'

// Add all icons to the library
library.add(
  // Text Formatting
  faBold,
  faItalic,
  faUnderline,
  faSmile,
  faListOl,
  faListUl,
  // Navigation & UI
  faBars,
  faChartPie,
  faMobileAlt,
  faUserCircle,
  faTimes,
  faChevronDown,
  faChevronUp,
  faChevronLeft,
  faChevronRight,
  faEllipsisV,
  faEllipsisH,
  faArrowLeft,
  faCaretDown,
  faCaretUp,
  
  // User & Account
  faUser,
  faUsers,
  faCog,
  faSignOutAlt,
  faKey,
  faCrown,
  faReceipt,
  faLock,
  faShieldAlt,
  faIdCard,
  
  // Actions
  faPlus,
  faEdit,
  faTrash,
  faSave,
  faCheck,
  faCopy,
  faDownload,
  faUpload,
  faRefresh,
  faSyncAlt,
  faPowerOff,
  faRedo,
  faUndo,
  faMagic,
  faWandMagicSparkles,
  
  // Visibility
  faEye,
  faEyeSlash,
  
  // Search & Filter
  faSearch,
  faFilter,
  faSort,
  faSortUp,
  faSortDown,
  
  // Date & Time
  faCalendar,
  faClock,
  faCalendarTimes,
  faInfinity,
  
  // Communication
  faEnvelope,
  faPhone,
  faBell,
  
  // Content
  faFileAlt,
  faFileCsv,
  faImage,
  faLink,
  faFolder,
  faFolderOpen,
  faFile,
  faDatabase,
  faInbox,
  faPlusCircle,
  faFileContract,
  
  // Status & Indicators
  faSpinner,
  faCircleNotch,
  faExclamationTriangle,
  faExclamationCircle,
  faInfoCircle,
  faCheckCircle,
  faTimesCircle,
  faQuestionCircle,
  
  // Business & Apps
  faHome,
  faChartBar,
  faChartLine,
  faGamepad,
  faTicketAlt,
  faGlobe,
  faCreditCard,
  faStore,
  faBullhorn,
  faBroadcastTower,
  faLayerGroup,
  faRocket,
  
  // Media Controls
  faPlay,
  faPause,
  faStop,
  
  // Social & Sharing
  faHeart,
  faStar,
  
  // Settings & Tools
  faCogs,
  faPalette,
  
  // Lists & Organization
  faList,
  faListAlt,
  faThLarge,
  
  // Other common icons
  faTrophy,
  faAward,
  faGift,
  faMapMarkerAlt,
  faBuilding,
  faArchive,
  faSortAmountDownAlt,
  faSortAmountUp,
  faArrowTrendUp,
  faArrowTrendDown,
  faArrowRight,
  // Game-specific icons
  faHammer,
  faSnowflake,
  faPaperPlane,
  faFrown,
  faCircle,
  faDesktop,
  // Brand icons
  faGoogle,
  faApple,
  faMicrosoft
)

// Export the FontAwesomeIcon component for use in Vue
export { FontAwesomeIcon }
